export default {
  partSpecification: 'Teilespezifikation',
  treatmentInformation: 'Information zur Behandlung',
  partImages: 'Teilefotos',
  treatmentRemark: 'Anmerkung zur Behandlung',
};
